import React, {Component} from 'react';

export default class Automate extends Component {
    render(){
        const carouselImg = require('images/brand_ambassadors/automate_carousel.png');
        const instagramIconImg = require('images/icons/instagram_icon.png');

        return(
            <div className='gr-12 automate'>
                <div className='row'>
                    <div className='gr-5 push-7 automate-text'>
                        <div className='gr-12 automate-text-header'>
                            <h1>Social Native 1 day initiative</h1>
                        </div>
                        <div className='gr-4 automate-text-influencers'>
                            <span>700+</span>
                            <p>brand ambassadors</p>
                        </div>
                        <div className='gr-4 automate-text-rate'>
                            <span>24</span>
                            <p>hours</p>
                        </div>
                        <div className='gr-4 automate-text-reached'>
                            <span>trending on</span>
                            <img src={instagramIconImg} />
                        </div>
                    </div>
                    <div className='gr-12 automate-image'>
                        <img src={carouselImg} className='automate-carousel-image' />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/automate.js